import { ThemeComponentTypes } from '../types'

export const SkeletonStyleOverrides: ThemeComponentTypes['MuiSkeleton'] = {
  styleOverrides: {
    root: {
      transform: 'none'
    }
  }
}
